<template>
    <PageLayout :has-buttons="true" :has-title="false" content-class="p-0" :has-page-scroll="false">
        <template v-if="isLoadError || isFormLoading || isSaveInProgress">
            <section class="card w-100 h-100 d-flex flex-column align-items-center justify-content-center">
                <div class="d-flex flex-column align-items-start" v-if="isLoadError && !isFormLoading">
                    <h5 class="fw-bold">Error</h5>
                    <p class="font-size-xl mb-1">
                        <template v-if="referralId">
                            There was problem while loading the referral. Please try again.
                        </template>
                        <template v-else>
                            There was problem while generating the referral form. Please try again.
                        </template>
                    </p>
                    <span class="mb-2"> </span>
                    <button class="btn btn-primary" @click="loadReferral()">Try Again</button>
                </div>
                <template v-if="isFormLoading && !isLoadError">
                    <i class="fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl">Loading Referral Form...</span>
                </template>
                <div v-if="isSaveInProgress" class="d-flex flex-column align-items-center">
                    <i class="far fa-save fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl text-center">Saving Referral...</span>
                </div>
            </section>
        </template>
        <template #content v-if="!isLoadError && !isFormLoading && !isSaveInProgress">
            <div id="HomeHealth_New_Referral">
                <div class="convert-header">
                    {{
                        `${!isCreate ? "Edit" : "Create"} Home Health Referral-${formatName(
                            referral.Referral.FirstName,
                            referral.Referral.LastName
                        )}`
                    }}
                </div>
                <div class="card m-2">
                    <div class="card-body form-content p-3 mx-lg-6">
                        <div class="mb-3">
                            <ReferralSourceInformation
                                :referral-options="referralOptions"
                                :referral="referral"
                                :is-editing="!isCreate"
                                :same-as-certifying-physician="sameAsCertifyingPhysician"
                            />
                        </div>
                        <div class="mb-3">
                            <DemographicsInformation
                                :referral-options="referralOptions"
                                :referral="referral"
                                :branch-id="branchId"
                                :is-editing="!isCreate"
                                :isRefer="isRefer"
                                :enable-validation="isPatientIdentifierEnabled"
                                v-on:changeBranchId="changeBranchId"
                            />
                        </div>
                        <div class="mb-3">
                            <FormSection title="Tags" :full-height="false" :application-id="referral.application">
                                <template #content>
                                    <section class="d-flex flex-column px-4 py-2">
                                        <PatientTags :patient="referral" />
                                    </section>
                                </template>
                            </FormSection>
                        </div>
                        <div class="mb-3">
                            <PayorInformation
                                :referral-options="referralOptions"
                                :referral="referral"
                                :branch-id="branchId"
                                :is-editing="!isCreate"
                                :is-refer="isRefer"
                                :enable-validation="isPatientIdentifierEnabled"
                            />
                        </div>
                        <div class="mb-3">
                            <ClinicalInformation
                                :referral-options="referralOptions"
                                :referral="referral"
                                :is-editing="!isCreate"
                                :is-refer="isRefer"
                                :change-certifying-physician="countPhysicianChange"
                                :get-certifying-physician="getCertifyingPhysician"
                            />
                        </div>
                        <FormSection
                            title="Referral Comments"
                            :full-height="false"
                            :application-id="referral.application"
                        >
                            <template #content>
                                <section class="d-flex flex-column px-4 py-2">
                                    <div class="form-group col-12">
                                        <CommentInput
                                            input-name="referral-comments"
                                            :result="referral.Referral.Comments"
                                            v-on:resultUpdatedAppended="resultUpdatedAppended"
                                            v-on:resultUpdated="resultUpdated"
                                            placeholder="Enter Comments"
                                            :class-list="commentInputClass"
                                            :application="referral.application"
                                            :max-length="2000"
                                        />
                                    </div>
                                </section>
                            </template>
                        </FormSection>
                    </div>
                </div>
                <footer
                    v-if="!isLoadError && !isFormLoading && !isSaveInProgress"
                    class="d-flex justify-content-center form-footer m-1 gap-2 mb-3"
                >
                    <button type="button" class="btn btn-primary me-2" @click="update()" v-if="!isCreate">
                        Save Referral
                    </button>
                    <button type="button" class="btn btn-primary me-2" @click="create()" v-else>Create Referral</button>
                    <button class="btn btn-outline-primary me-2" @click="goToReferralList()">View Referral List</button>
                    <button class="btn btn-outline-primary" @click="goToReferralList(true)">Cancel</button>
                </footer>
            </div>
        </template>
    </PageLayout>
</template>

<style src="./CreateReferralHomeHealth.scss"></style>
<script lang="ts" src="./CreateReferralHomeHealth.ts"></script>
